import {createActions} from '../../../baseClasses/ActionFactory';

const {types: generalTypes, actions: generalActions} = createActions({store: 'GEO_ZONE_LOADING_TYPES'});
const allActions = {...generalActions};
const allTypes = {...generalTypes};

export {allTypes as types, allActions as actions};
